import {all, fork, put, takeEvery, takeLatest} from 'redux-saga/effects';
import {
  ACCOUNT,
  AUTH_TOKEN,
  DOCS_SEARCH_TOKEN,
  INVITATION_SIGNUP,
  SEARCH_TOKEN,
  SIGNIN,
  SIGNOUT,
  SIGNUP,
  TOKENSIGNIN,
  TUTORIAL,
  UPDATE_AVATAR,
  UPDATE_CURRENT_PASSWORD,
  UPDATE_CURRENT_USER,
  USER,
} from '../constants/Auth';
import {authenticated, hideLoading, showAuthMessage, signOutSuccess, signUpSuccess,} from '../actions/Auth';
import EstService from '../../services/EstService';
import NotificationService from '../../services/NotificationService';
import {
  ACCOUNT_COMPLETE_TUTORIAL,
  ACCOUNT_CURRENT,
  ACCOUNT_GET_INTEGRATIONS,
  ACCOUNT_PUT,
  ACCOUNT_UPDATE,
} from 'redux/constants/Accounts';
import {
  completeTutorialSuccess,
  getCurrentAccountSuccess,
  getIntegrationsSuccess,
  putAccountSuccess,
  updateAccountSuccess,
} from 'redux/actions/Accounts';
import {setLoadingInvisible, setLoadingVisible, updateBillingSuccess,} from 'redux/actions';
import {BILLING_UPDATE} from 'redux/constants/Billing';
import {AUTH_PREFIX_PATH} from 'configs/AppConfig';

export function* signIn() {
  yield takeEvery(SIGNIN, function* ({ payload }) {
    try {
      const response = yield EstService.login(payload);
      localStorage.setItem(AUTH_TOKEN, response.token);
      localStorage.setItem(SEARCH_TOKEN, response.search_token);
      localStorage.setItem(DOCS_SEARCH_TOKEN, response.docs_search_token);
      localStorage.setItem(USER, JSON.stringify(response.user));
      localStorage.setItem(ACCOUNT, JSON.stringify(response.account));
      localStorage.setItem(TUTORIAL, JSON.stringify(response.tutorial));

      // window.startOrUpdatePendo()

      yield put(authenticated(response));
    } catch (err) {
      console.log(err);
      yield put(showAuthMessage(err.response.data.message));
    }
  });
}

export function* updateCurrentUser() {
  yield takeEvery(UPDATE_CURRENT_USER, function* ({ user }) {
    try {
      const response = yield EstService.updateCurrentUser(user);
      localStorage.setItem('user', JSON.stringify(response.data));
      // window.startOrUpdatePendo()
      NotificationService.success('User updated');
    } catch (err) {
      console.log(err);
    }
  });
}

export function* updateAccount() {
  yield takeEvery(ACCOUNT_UPDATE, function* ({ accountId, data }) {
    try {
      const response = yield EstService.updateAccount(accountId, data);
      localStorage.setItem(ACCOUNT, JSON.stringify(response.data));
      // window.startOrUpdatePendo()
      yield put(getCurrentAccountSuccess(response.data));
      yield put(updateAccountSuccess(accountId, response.data));
      NotificationService.success(response.message);
    } catch (err) {
      console.log(err);
    }
  });
}

export function* putAccount() {
  yield takeEvery(ACCOUNT_PUT, function* ({ accountId, data }) {
    try {
      const response = yield EstService.updateAccount(accountId, data);
      localStorage.setItem(ACCOUNT, JSON.stringify(response.data));
      // window.startOrUpdatePendo()
      yield put(getCurrentAccountSuccess(response.data));
      yield put(putAccountSuccess(accountId, response.data));
      NotificationService.success('Account settings updated');
    } catch (err) {
      console.log(err);
    }
  });
}

export function* getCurrentAccount() {
  yield takeEvery(ACCOUNT_CURRENT, function* () {
    try {
      const response = yield EstService.getCurrentAccount();
      yield put(getCurrentAccountSuccess(response.data));
    } catch (err) {
      console.log(err);
    }
  });
}

export function* getIntegrations() {
  yield takeEvery(ACCOUNT_GET_INTEGRATIONS, function* () {
    try {
      const response = yield EstService.getIntegrations();
      yield put(getIntegrationsSuccess(response.data));
    } catch (err) {
      console.log(err);
    }
  });
}

export function* updateBilling() {
  yield takeEvery(
    BILLING_UPDATE,
    function* ({ creditCardNumber, expireMonth, expireYear, cvc }) {
      try {
        yield put(setLoadingVisible());
        const response = yield EstService.updateBilling({
          credit_card_number: creditCardNumber,
          expire_month: expireMonth,
          expire_year: expireYear,
          cvc,
        });
        localStorage.setItem(ACCOUNT, JSON.stringify(response.data));
        yield put(updateBillingSuccess(response.data));
        yield put(setLoadingInvisible());
      } catch (err) {
        console.log(err);
        yield put(setLoadingInvisible());
      }
    }
  );
}

export function* updateCurrentPassword() {
  yield takeEvery(UPDATE_CURRENT_PASSWORD, function* ({ payload }) {
    try {
      yield EstService.updateCurrentPassword({
        password: payload.password,
        new_password: payload.newPassword,
        new_password_confirmation: payload.newPasswordConfirmation,
      });
      NotificationService.success('Password updated');
    } catch (err) {
      console.log(err);
    }
  });
}

export function* updateAvatar() {
  yield takeEvery(UPDATE_AVATAR, function ({ avatar }) {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      user.avatar = avatar;
      localStorage.setItem('user', JSON.stringify(user));
      NotificationService.success('Avatar Updated');
    } catch (err) {
      console.log(err);
    }
  });
}

export function* tokenSignIn() {
  yield takeEvery(
    TOKENSIGNIN,
    function* ({ token, searchToken, docsSearchToken }) {
      try {
        localStorage.setItem(AUTH_TOKEN, token);
        localStorage.setItem(SEARCH_TOKEN, searchToken);
        localStorage.setItem(DOCS_SEARCH_TOKEN, docsSearchToken);
        const response = yield EstService.user();
        localStorage.setItem(USER, JSON.stringify(response.data));
        localStorage.setItem(ACCOUNT, JSON.stringify(response.account));
        localStorage.setItem(TUTORIAL, JSON.stringify(response.data.tutorial));
        const data = {
          token,
          searchToken,
          user: response.data,
          account: response.account,
          tutorial: response.data.tutorial,
        };
        yield put(authenticated(data));
      } catch (err) {
        console.log(err);
        yield put(showAuthMessage(err.response.data.message));
      }
    }
  );
}

export function* signUp() {
  yield takeEvery(SIGNUP, function* ({ payload }) {
    try {
      const response = yield EstService.register(payload);
      localStorage.setItem(AUTH_TOKEN, response.token);
      localStorage.setItem(SEARCH_TOKEN, response.search_token);
      localStorage.setItem(DOCS_SEARCH_TOKEN, response.docs_search_token);
      localStorage.setItem(USER, JSON.stringify(response.user));
      localStorage.setItem(ACCOUNT, JSON.stringify(response.account));
      localStorage.setItem(TUTORIAL, JSON.stringify(response.tutorial));
      // window.startOrUpdatePendo()
      yield put(signUpSuccess(response));
    } catch (err) {
      let error_message = Object.values(err.response.data.errors).join(' ');
      yield put(showAuthMessage(error_message));
      yield put(hideLoading());
    }
  });
}

export function* invitationSignUp() {
  yield takeEvery(INVITATION_SIGNUP, function* ({ payload }) {
    try {
      const response = yield EstService.invitation_register(payload);
      localStorage.setItem(AUTH_TOKEN, response.token);
      localStorage.setItem(SEARCH_TOKEN, response.search_token);
      localStorage.setItem(DOCS_SEARCH_TOKEN, response.docs_search_token);
      localStorage.setItem(USER, JSON.stringify(response.user));
      localStorage.setItem(ACCOUNT, JSON.stringify(response.account));
      localStorage.setItem(TUTORIAL, JSON.stringify(response.tutorial));
      // window.startOrUpdatePendo()
      yield put(signUpSuccess(response));
    } catch (err) {
      let error_message = Object.values(err.response.data.errors).join(' ');
      yield put(showAuthMessage(error_message));
      yield put(hideLoading());
    }
  });
}

export function* signOut() {
  yield takeLatest(SIGNOUT, function* ({ history }) {
    try {
      yield EstService.logout();
      localStorage.clear();
      yield put(signOutSuccess());
      if (history) {
        history.replace(`${AUTH_PREFIX_PATH}/login`);
      }
    } catch (err) {
      console.log(err);
    }
  });
}

export function* completeTutorial() {
  yield takeEvery(ACCOUNT_COMPLETE_TUTORIAL, function* ({ id }) {
    try {
      yield EstService.completeTutorial(id);
      yield put(completeTutorialSuccess());
      localStorage.removeItem(TUTORIAL);
    } catch (err) {
      console.log(err);
      NotificationService.error(err);
    }
  });
}

export default function* authSaga() {
  yield all([
    fork(signIn),
    fork(updateAvatar),
    fork(updateCurrentUser),
    fork(getCurrentAccount),
    fork(updateAccount),
    fork(getIntegrations),
    fork(putAccount),
    fork(updateBilling),
    fork(updateCurrentPassword),
    fork(tokenSignIn),
    fork(signOut),
    fork(signUp),
    fork(invitationSignUp),
    fork(completeTutorial),
  ]);
}
